import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

import WpImage from "../components/WpImage";
import ArrowIcon from "../icons/arrow-16.svg";

const TilesNew = ({ items, activeCat, isLoaded, className }) => (
    <Row className="tiles-n__row">
        {items
            .filter(
                (item) =>
                    !activeCat ||
                    activeCat === item.cat ||
                    item.cat.includes(activeCat)
            )
            .map((item, index) => (
                <Col
                    key={item.order || `${item.cat}-${index}`}
                    className={`col-24 col-md-12 col-xl-8 cmb-4 ${
                        isLoaded ? "" : "d-none"
                    }`}
                >
                    <TileNew
                        style={{
                            animationDelay: `${index < 10 ? index * 0.1 : 1}s`,
                        }}
                        {...item}
                        className={className}
                    />
                </Col>
            ))}
    </Row>
);

const TileNew = ({
    className = "",
    coverImage,
    coverHeader,
    coverText,
    tileText,
    linkedInUrl,
    ...attrs
}) => {
    const [isActive, setIsActive] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    const handleLinkedInClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent?.stopImmediatePropagation?.();

        const newWindow = window.open(linkedInUrl, "_blank");

        if (newWindow) {
            newWindow.opener = null;
        }
    };

    return (
        <div
            className={`team-card ${isActive ? "-active" : ""} ${className}`}
            onTouchMove={() => setIsDragging(true)}
            onTouchStart={() => setIsDragging(false)}
            onTouchEnd={() => {
                if (!isDragging) {
                    setIsActive(!isActive);
                }
            }}
            onMouseEnter={() => setIsActive(true)}
            onMouseLeave={() => setIsActive(false)}
            {...attrs}
        >
            <div className="team-card__front">
                {coverImage && (
                    <WpImage className="team-card__image" image={coverImage} />
                )}

                <div className="team-card__content">
                    {coverHeader && (
                        <h3 className="team-card__name">{coverHeader}</h3>
                    )}

                    {coverText && (
                        <p className="team-card__role">{coverText}</p>
                    )}
                </div>
            </div>

            <div className="team-card__back">
                {tileText && <p className="team-card__bio">{tileText}</p>}

                <div className="team-card__content">
                    {coverHeader && (
                        <h3 className="team-card__name">{coverHeader}</h3>
                    )}

                    {coverText && (
                        <p className="team-card__role">{coverText}</p>
                    )}

                    {linkedInUrl && (
                        <a
                            href={linkedInUrl}
                            target="_blank"
                            rel="nofollow noopener noreferrer"
                            className="team-card__linkedin"
                            onMouseDown={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                            onTouchEnd={(e) => e.stopPropagation()}
                            onClickCapture={handleLinkedInClick}
                        >
                            LinkedIn
                            <ArrowIcon className="team-card__linkedin-arrow" />
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TilesNew;
